import { AxiosError } from 'axios';

/**
 * A refused file download (`responseType: 'blob'`) carries its problem details as a Blob. Read as
 * JSON here, its code and detail reach the problem-details toast and every caller like any other
 * refusal's. A body that is not JSON stays as it came.
 */
export async function blobErrorBodyInterceptor(error: unknown): Promise<never> {
  if (error instanceof AxiosError && error.response?.data instanceof Blob) {
    try {
      const text = new TextDecoder().decode(await error.response.data.arrayBuffer());
      error.response.data = JSON.parse(text) as unknown;
    } catch {
      // Not JSON: nothing more to read from it.
    }
  }
  throw error;
}
